import { removeGiftAuthorApi } from 'api/gifts/removeGiftAuthorApi'

export const REMOVE_AUTHOR_GIFT = 'REMOVE_AUTHOR_GIFT' as const

export const removeGiftAuthorAction = (giftId: number) => ({
  type: REMOVE_AUTHOR_GIFT,
  promise: () => removeGiftAuthorApi(giftId),
})
